import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '../environment/environment.service';
import { ApiService } from './api.service'
import { Storage } from '@ionic/storage-angular';

export const ApiServiceFactory = (http: HttpClient, env: EnvironmentService, storage: Storage) => {
    return new ApiService(http, env, storage);
}

export const ApiServiceProvider = {
    provide: ApiService,
    useFactory: ApiServiceFactory,
    deps: [
        HttpClient,
        EnvironmentService,
        Storage
    ],
}